const showMore = function()
{
  var items = document.querySelectorAll('.js--show-more');


  items.forEach(el => {
    el.addEventListener('click', function(e) {
      e.preventDefault();
  
      var target = document.querySelector(this.dataset.target);

      this.classList.toggle('is-show');

      this.innerHTML = this.innerHTML.replace('show', 'hide')


      let text = this.querySelector('span');

      if(text) {
        text.innerHTML = this.classList.contains('is-show') ? this.dataset.hide : this.dataset.show;
      }
      

      target.classList.toggle('is-show');
    });
  });

  
  
}

export default showMore();